// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2qpkc","content":"Consent_content__10ZAg","footer":"Consent_footer__3OEGN"};